import { render, staticRenderFns } from "./simple-crud.vue?vue&type=template&id=906da006&lang=html&"
import script from "./simple-crud.vue?vue&type=script&lang=js&"
export * from "./simple-crud.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Devdoc\\_packages\\moss-ui\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('906da006')) {
      api.createRecord('906da006', component.options)
    } else {
      api.reload('906da006', component.options)
    }
    module.hot.accept("./simple-crud.vue?vue&type=template&id=906da006&lang=html&", function () {
      api.rerender('906da006', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/js/components/simple-crud.vue"
export default component.exports